import { AddSchoolInformationContainer, AddGradeContainer, ElectivesContainer, WeeklyCalendarContainer, EditSchoolInformationContainer, SubjectContainer, SharedRoomContainer, TeacherContainer } from '..';
import * as Constants from '../../../../constants';

export const getAddStepperJsonArray = (i18n) => {
    const addStepperJsonArray = [
        {
            id: 0,
            displayName: i18n.schoolStepper.schoolInformation,
            container: AddSchoolInformationContainer

        },
        {
            id: 1,
            displayName: i18n.schoolStepper.grades,
            container: AddGradeContainer
        },

        {
            id: 2,
            displayName: i18n.schoolStepper.subjects,
            container: SubjectContainer
        },
        {
            id: 3,
            displayName: i18n.schoolStepper.electives,
            container: ElectivesContainer
        },
        {
            id: 4,
            displayName: i18n.schoolStepper.teachers,
            container: TeacherContainer,

        },
        {
            id: 5,
            displayName: i18n.schoolStepper.sharedRooms,
            container: SharedRoomContainer,
        }

    ];
    return addStepperJsonArray
}

export const getEditStepperJsonArray = (i18n) => {
    const editStepperJsonArray = [
        {
            id: 0,
            displayName: i18n.schoolStepper.schoolInformation,
            container: EditSchoolInformationContainer
        },
        {
            id: 1,
            displayName: i18n.schoolStepper.grades,
            container: AddGradeContainer
        },

        {
            id: 2,
            displayName: i18n.schoolStepper.subjects,
            container: SubjectContainer
        },
        {
            id: 3,
            displayName: i18n.schoolStepper.electives,
            container: ElectivesContainer
        },
        {
            id: 4,
            displayName: i18n.schoolStepper.teachers,
            container: TeacherContainer
        },
        {
            id: 5,
            displayName: i18n.schoolStepper.sharedRooms,
            container: SharedRoomContainer,
        }
    ];
    return editStepperJsonArray
}

export const STEPPER_STATE_KEY_LS = Constants.STEPPER_STATE_KEY_LS;


